export const UPCOMING = 0;
export const TODAY = 1;
export const PASSED = 2;

export const RESULTS = 3;
